var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('download_app', { snName: _vm.selectedSn.name, snNameRu: _vm.selectedSn.nameRu }))+" ")]),_c('AppLinks',{staticClass:"app-links",attrs:{"color":_vm.$scss.n10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }